import React, { useState } from "react";
import { SCCustomerFilterStatement, SCCustomerDateError } from "./css";
import { connect } from "react-redux";
import moment from "moment";
import { renderCalendarStandard } from "../Common/FormFields";
import { Button, IconExport, styled } from "@payright/web-components";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Loader from "../Common/Loader";
import StatementsTable from "./StatementsTable";
import StatementModal from "./modal/StatementModal";
import { CustomerStatementVM } from "./actions/CustomerStatementVM";

const StatementFormWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

let CustomerStatementForm = (props) => {
  const { error, loading, handleSubmit } = props;
  const [selectedStatementId, setSelectedStatementId] = useState<
    string | undefined
  >(undefined);
  const [selectedFromDate, setSelectedFromDate] = useState<string | undefined>(
    undefined
  );
  const [selectedToDate, setSelectedToDate] = useState<string | undefined>(
    undefined
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [latestStatementDate, setLatestStatementDate] = useState(new Date());

  const handleViewStatement = (statement: CustomerStatementVM) => {
    setSelectedStatementId(statement.id);
    setSelectedFromDate(statement.fromDate);
    setSelectedToDate(statement.toDate);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedStatementId(undefined);
    setSelectedFromDate(undefined);
    setSelectedToDate(undefined);
  };

  const handleNewStatementGenerated = () => setLatestStatementDate(new Date());

  const handleFormSubmit = async (values) => {
    const { fromDate, toDate } = values;

    if (!fromDate) {
      throw new SubmissionError({ _error: "From date is required." });
    } else if (!toDate) {
      throw new SubmissionError({ _error: "To date is required." });
    }

    setSelectedFromDate(fromDate);
    setSelectedToDate(toDate);
    setIsModalOpen(true);
  };

  return (
    <StatementFormWrapper>
      <SCCustomerFilterStatement>
        <form
          className="StatementForm"
          onSubmit={handleSubmit(handleFormSubmit)}
        >
          <div className="containerStatement">
            <Field
              label="From Date"
              name="fromDate"
              maxWidth="50%"
              component={renderCalendarStandard}
            />
            <Field
              label="To Date"
              name="toDate"
              maxWidth="50%"
              component={renderCalendarStandard}
            />
            <Button
              colour="blue"
              size="small"
              outline
              icon={<IconExport />}
              iconPosition="left"
              type="submit"
              className="button-generate"
            >
              {" "}
              Generate Statement
            </Button>
          </div>
        </form>
      </SCCustomerFilterStatement>

      {error && <SCCustomerDateError>{error}</SCCustomerDateError>}

      <StatementsTable onViewStatement={handleViewStatement} latestStatementDate={latestStatementDate} />

      {isModalOpen && (
        <StatementModal
          onClose={handleCloseModal}
          onNewStatementGenerated={handleNewStatementGenerated}
          statementId={selectedStatementId}
          fromDate={selectedFromDate}
          toDate={selectedToDate}
        />
      )}

      {loading ? <Loader text="Generating statement..." /> : ""}
    </StatementFormWrapper>
  );
};

CustomerStatementForm = reduxForm({
  form: "CustomerStatementForm",
  enableReinitialize: true,
})(CustomerStatementForm);

const mapStateToProps = function (state) {
  return {
    initialValues: {
      fromDate: moment()
        .subtract(1, "days")
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    },
    error: state.pageData.error,
    loading: state.pageData.loading,
  };
};
export default connect(mapStateToProps)(CustomerStatementForm);
